<template>
  <div class="contract_browse">
    <van-sticky>
      <van-nav-bar title="合同浏览" left-arrow @click-left="goback()" />
    </van-sticky>

    <van-cell
      title="签约日期"
      size="large"
      :value="contractData.signTime"
    ></van-cell>
    <van-cell
      title="到期日期"
      size="large"
      :value="contractData.expirationTime"
    ></van-cell>

    <div class="browse_img">合同照片<span style="color:red;font-size: 13px;">（*点击图片可放大预览）</span></div>

    <van-image
      v-for="item in contractData.contractImageList"
      :key="item"
      width="100%"
      :src="item.url"
      height="300"
      fit="scale-down"
      @click="showImage(item)"
    />

    <van-button color="#0CA7F0" block @click="orderInfoUserH5DownloadZip"
      >合同下载</van-button
    >

    <div @click="isShowImage = false" v-if="isShowImage" style="position:fixed;top:0px;left:0px;width: 100%;height: 100%;background: rgba(0,0,0,0.5);z-index:10">
        <van-image
        @click="isShowImage = false"
          width="100%"
          :src="targetImage"
          height="100%"
          fit="scale-down"
        />
    </div>

  </div>
</template>

<script>
import { NavBar, Button, Cell, Image, Sticky } from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
  },
  data() {
    return {
      params: {
        order_info_id: 21,
      },

      contractData: [],

      targetImage:'',

      isShowImage:false,
    };
  },

  created() {
    this.params.order_info_id = this.$route.query.id;
    //订单-合同浏览
    this.contractuserH5Detail();
  },

  methods: {
    showImage(item){
      this.isShowImage = true
      this.targetImage = item.url
    },
    //订单-合同浏览
    contractuserH5Detail() {
      var that = this;
      that.$api
        .contractuserH5DetailAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            that.contractData = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //订单-下载合同
    orderInfoUserH5DownloadZip() {
      var that = this;
      that.$api
        .orderInfoUserH5DownloadZipAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            window.location.href = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.contract_browse {
  .browse_img {
    background: #f4f3f8;
    padding: 10px 16px;
    color: #666;
    font-size: 15px;
  }

  .van-button {
    position: fixed;
    bottom: 0px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/order/contractBrowse.vue